module.exports = __webpack_public_path__ + "img/Who.9456673f.png";